export function StringDate(date) {
    if(!date) {
        return "";
    }
    return new Date(date).toLocaleString();
}
